import { Sidebar } from "./Sidebar";
import Topbar from './Topbar';

Topbar();

const sidebar = new Sidebar('aside#sidebar');
